// import something here

// "async" is optional;
// more info on params: https://quasar.dev/quasar-cli/boot-files
export default ({ Vue }) => {
  const vars = {
    table: {
      pagination: {
        rowsPerPage: 10,
        sortBy: null
      },
    }
  }

  Vue.prototype.$qvars = vars
}
